module.exports = __webpack_public_path__ + "static/media/scenario.7703808c.svg";